// extracted by mini-css-extract-plugin
module.exports = {"promoted":"Promoted_promoted__I_M8a","button":"Promoted_button__McHH_"};